import { useReveal, useCountUp } from "../hooks";

const LOGOS = [
  ["/assets/partner-telus.png", "TELUS", ""],
  ["/assets/partner-bell.png", "Bell", "lg"],
  ["/assets/partner-powerq.png", "PowerQ", "lg"],
  ["/assets/partner-jds.png", "JDS Media", ""],
];

export const Partners = () => (
  <section className="partners" data-testid="partners-section">
    <p className="partners-label">Trusted by industry-leading brands across North America</p>
    <div className="partners-row">
      <div className="partners-track">
        {[0, 1, 2].map((n) => LOGOS.map(([src, alt, cls], i) => (
          <img key={`${n}-${i}`} src={src} alt={alt} className={cls} loading="lazy" />
        )))}
      </div>
    </div>
  </section>
);

const STATS = [
  { target: 15, prefix: "$", suffix: "M+", label: "Revenue Generated", sub: "For partner brands" },
  { target: 200, prefix: "", suffix: "+", label: "Trained Sales Professionals", sub: "Across multiple channels" },
  { target: 3, prefix: "", suffix: "", label: "Multi-Market Operations", sub: "Active across North America" },
  { target: 10, prefix: "", suffix: "K+", label: "Customer Acquisitions", sub: "Acquired through outreach" },
];

const StatCell = ({ s, inView, i }) => {
  const v = useCountUp(s.target, inView, 1600 + i * 200);
  return (
    <div className="stat-cell" data-testid={`stat-cell-${i}`}>
      <div className="stat-num">{s.prefix}{v}{s.suffix}</div>
      <div className="stat-label">{s.label}</div>
      <div className="stat-sub">{s.sub}</div>
    </div>
  );
};

export const Stats = () => {
  const [ref, inView] = useReveal(0.3);
  return (
    <section className="sec stats" data-testid="stats-section">
      <div className="container">
        <div ref={ref} className={`reveal ${inView ? "in" : ""}`}>
          <span className="eyebrow">By the numbers</span>
          <h2 className="h-display">Focus on scaling your business —<br />we'll scale your sales.</h2>
          <p className="lead" style={{ marginBottom: 50 }}>
            Real growth through face-to-face sales and strategic partnerships, nationwide.
          </p>
          <div className="stats-grid">
            {STATS.map((s, i) => <StatCell key={i} s={s} inView={inView} i={i} />)}
          </div>
        </div>
      </div>
    </section>
  );
};
